module.exports = __webpack_public_path__ + "static/media/ic_blood.626236c0.svg";